import { TableField } from "../../table-field";

const detalhes: TableField = {
    key: "show_details",
    label: "Detalhes",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
}
const nome: TableField = {
    key: "nome",
    label: "Nome",
    tdClass: ["quebrarPorPalavra", "text-center"],
    thClass: ["text-center"],
    sortable: true,
    formatter: (
        value: any,
        key: string, // nome da const
        item: any // response
    ): string => {
        return item?.IdCargoNavigation?.DeNomenclaturaCargo ||
            item?.IdCargoProcessoSeletivoNavigation?.DsNomenclatura ||
            "";
    }
}
const remuneracao: TableField = {
    key: "remuneracao_inicial",
    label: "Remuneração Inicial",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: true,
}
const localidade: TableField = {
    key: "localidade",
    label: "Localidade",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: true,
}
const especialidade: TableField = {
    key: "especialidade",
    label: "Especialidade",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: true,
}
const actions: TableField = {
    key: "actions",
    label: "Ações",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: false,
}
export const fieldsCargos: TableField[] = [
    detalhes,
    nome,
    remuneracao,
    localidade,
    especialidade,
    actions
];
